import { render } from "./TheConsumersContainer.vue?vue&type=template&id=465d70af"
import script from "./TheConsumersContainer.vue?vue&type=script&lang=js"
export * from "./TheConsumersContainer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__